<template>
  <div>
    <FullPageLoader />
    <router-view></router-view>
  </div>
</template>

<script setup>
import axios from 'axios'
import FullPageLoader from './components/FullPageLoader.vue'
import { ref, provide } from 'vue'

const loading = ref(false)
provide('loading', loading)

// Axios interceptors
axios.interceptors.request.use((config) => {
  loading.value = true
  return config
}, (error) => {
  loading.value = false
  return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
  loading.value = false
  return response
}, (error) => {
  loading.value = false
  return Promise.reject(error)
})


</script>

<style lang="scss" scoped></style>